import { AppointmentButtonServant } from './appointment_button_servant';
import { AppointmentInfoServant } from './appointment_info_servant';
import { AppointmentRemindersServant } from './appointment_reminders_servant';
import { AppointmentsAvailableTimesServant } from './appointments_available_times_servant';
import { AppointmentsChoiceSelectorServant } from './appointments_choice_selector_servant';
import { AppointmentsCommandServant } from './appointments_command_servant';
import { AppointmentsconfirmServant } from './appointments_confirm_servant';
import { AppointmentsTabsConfiguration } from './appointments_tabs_configuration';
import { AppointmentUsersourceServant } from './appointments_usersource_servant';
import { CurrentUserAppointmentsServant } from './current_user_appointments_servant';
import { LocalStorageServant } from './local_storage_servant';
import { PrepareAppointmentCampaignServant } from './prepare_appointment_campaign_request_servant';

angular
  .module('capability-ng-appointments')
  .service('ngAppointmentsCommandServant', AppointmentsCommandServant)
  .service('ngAppointmentsconfirmServent', AppointmentsconfirmServant)
  .service('ngAppointmentUsersourceServant', AppointmentUsersourceServant)
  .service('ngAppointmentsAvailableTimesServant', AppointmentsAvailableTimesServant)
  .service('ngAppointmentRemindersServant', AppointmentRemindersServant)
  .provider('ngAppointmentsTabsConfiguration', AppointmentsTabsConfiguration)
  .service('ngCurrentUserAppointmentsServant', CurrentUserAppointmentsServant)
  .service('ngPrepareAppointmentCampaignServant', PrepareAppointmentCampaignServant)
  .service('ngLocalStorageServant', LocalStorageServant)
  .service('ngAppointmentInfoServant', AppointmentInfoServant)
  .service('ngAppointmentsChoiceSelectorServant', AppointmentsChoiceSelectorServant)
  .service('ngAppointmentButtonServant', AppointmentButtonServant);

export * from './appointment_reminders_servant';
export * from './appointments_available_times_servant';
export * from './appointments_command_servant';
export * from './appointments_confirm_servant';
export * from './appointments_tabs_configuration';
export * from './appointments_usersource_servant';
export * from './current_user_appointments_servant';
export * from './local_storage_servant';
export * from './prepare_appointment_campaign_request_servant';
export * from './appointment_info_servant';
export * from './appointment_button_servant';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/servants/servants_module.ts